import React from "react";
import { motion } from "framer-motion";
import ChoiceMagneticButton from "../shared/ChoiceMagneticButton.jsx";
import { scrollToId } from "../shared/utils.js";

const StickyMobileBar = ({ visible, onOpenCustomModal }) => {
  if (!visible) return null;

  return (
    <motion.div
      className="fixed bottom-0 inset-x-0 z-40 md:hidden border-t border-white/10 bg-[#080b14]/95 backdrop-blur-md"
      initial={{ y: 100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: 100, opacity: 0 }}
      transition={{ duration: 0.25, ease: [0.4, 0, 0.2, 1] }}
      data-testid="sticky-mobile-bar"
      style={{ paddingBottom: "env(safe-area-inset-bottom, 0px)" }}
    >
      <div className="flex gap-2 p-3">
        <ChoiceMagneticButton
          className="flex-1 bg-gradient-to-r from-teal-500 via-emerald-500 to-teal-500 px-4 py-3 rounded-xl font-semibold text-sm"
          onClick={() => scrollToId("plug-play")}
          data-testid="sticky-cta-deploy"
        >
          Deploy
        </ChoiceMagneticButton>
        <ChoiceMagneticButton
          primary={false}
          className="flex-1 border border-purple-500/40 bg-purple-500/10 text-purple-300 px-4 py-3 rounded-xl font-semibold text-sm"
          onClick={onOpenCustomModal}
          data-testid="sticky-cta-custom"
        >
          Request Custom
        </ChoiceMagneticButton>
      </div>
    </motion.div>
  );
};

export default StickyMobileBar;
